import React from "react";
import { bool, string } from "prop-types";
import './styles.scss';

function ProfileBadge({ image = '', inHeader = false, height = 35, width = 35 }) {
  if (image && image !== 'null') {
    return (
      <img
        alt="Foto de perfil"
        src={image}
        className={`${inHeader ? 'profile-image' : ''}`}
        height={height}
        width={width}
      />
    );
  }
  else {
    return <i className="counter-icon bi bi-person-circle" aria-hidden="true"></i>
  }
}

ProfileBadge.propTypes = {
  image: string,
  height: string,
  width: string,
  inHeader: bool,
};


export default ProfileBadge;
